module.exports = __webpack_public_path__ + "img/IMG_2230.85cee67b.jpg";